export const findFirstFocusableElement = (element) => {
    let focusable = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return focusable.length > 0 ? focusable[0] : undefined;
};
export const focusFirstFocusableElement = (element) => {
    // it seems that calling it synchronously competes with some screen readers for focus and loses not focusing anything
    setTimeout(() => (findFirstFocusableElement(element) ?? element).focus(), 0);
};
//# sourceMappingURL=findFirstFocusableElement.js.map